import React, { useState ,useEffect } from "react";
import axios from 'axios'
import toast from "react-hot-toast";
import { FaSearch,} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import socket from "../socket";

function MachineList({token}) {
  const navigate = useNavigate();

 const [searchTerm, setSearchTerm] = useState('');
const[list,setList] = useState([]);
const [showForm, setShowForm] = useState(false);
const [showMachineModal, setShowMachineModal] = useState(false);
const [selectedMachine, setSelectedMachine] = useState(null);
const [showAvailable, setShowAvailable] = useState(true);


  
useEffect(() => {
  const handleNewEnquiry = (data) => {
      fetchMachineList();
    toast.success(data.title);
  };

  socket.on("new-vehicle-enquiry", handleNewEnquiry);
  return () => {
    socket.off("new-vehicle-enquiry", handleNewEnquiry);
    socket.off("connect");
  };
}, []);




const fetchMachineList = async () => {
  try {
    const res = await axios.get("https://api.krimotion.in/fetch-machine-list",
       {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
    )
    const result = res.data;
 
    setList(result);
  } catch (error) {
    console.log(error);
  }
};

   useEffect(() => {
    fetchMachineList();

  }, []);

  //  const filteredData = Array.isArray(list)
  //   ? list.filter(itm =>
  //     Object.values(itm).some(val =>
  //       String(val).toLowerCase().includes(searchTerm.toLowerCase())
  //     )
  //   )
  //   : [];

  const filteredData = Array.isArray(list)
  ? list.filter((itm) => {
      // Search filter
      const matchesSearch = Object.values(itm).some((val) =>
        String(val).toLowerCase().includes(searchTerm.toLowerCase())
      );

      // Status filter
      const matchesStatus = showAvailable
        ? itm.status === "Available"
        : itm.status === "Not Available";

      return matchesSearch && matchesStatus;
    })
  : [];


  return (
   <>
    <div className="container py-4">
          <div className="border-0  mb-3 px-2 py-2  ">
            
              <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
            
            
                <div className="d-flex align-items-center">
                  <h4 className="fw-bold mb-0" style={{ fontSize: "20px" }}>
                   User Vehicle List
                  </h4>
                </div>
            
                {/* CENTER SEARCH */}
            <div style={{ flex: 1, maxWidth: "250px" }}>
              <div
                className="d-flex align-items-center rounded-pill overflow-hidden"
                style={{
                  border: "1px solid var(--green)",
                  height: "34px",
                  paddingLeft: "8px",
                  paddingRight: "8px",
                  backgroundColor:'white'
                }}
              >
                {/* ICON */}
                <FaSearch
                  style={{
                    color: "var(--green)",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center"
                  }}
                />
            
                {/* INPUT */}
                <input
                  type="text"
                  className="form-control border-0 shadow-none"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{
                    fontSize: "14px",
                    height: "32px",
                    marginLeft: "6px",
                    lineHeight: "32px"
                  }}
                />
              </div>
            </div>
              </div>
            </div>
                         {!showForm && (
  <>

<div className="d-flex justify-content-end mb-3">
  <div
    className="d-flex align-items-center px-3 py-2 rounded-pill shadow-sm"
    style={{
      background: "#fff",
      border: "1px solid #e5e7eb",
      gap: "4px",
    }}
  >
    <span
      className={`fw-semibold ${
        showAvailable ? "text-success" : "text-danger"
      }`}
      style={{ minWidth: "110px" }}
    >
      {showAvailable ? "Available Vehicles" : "Not Available"}
    </span>

    <div className="form-check form-switch m-1">
      <input
        className="form-check-input"
        type="checkbox"
        checked={!showAvailable}
        onChange={() => setShowAvailable(!showAvailable)}
        style={{
          width: "3rem",
          height: "1.5rem",
          cursor: "pointer",
        }}
      />
    </div>
  </div>
</div>



    <div className="container-fluid mt-4">
      <div className="row g-4">

        {filteredData.length > 0 ? (
          filteredData.map((dealer, index) => (
            <div className="col-xl-4 col-lg-6 col-md-6" key={index}>

              <div className="inventory-card d-flex flex-column h-100">

                {/* Top */}
                <div className="d-flex">

                

                  <div className="ms-1 flex-grow-1">

                    <h5 className="inventory-title mb-1">
                      {dealer.machine_name}
                    </h5>

                    <span
                      className={`badge ${
                        dealer.status === "Available"
                          ? "bg-success"
                          : "bg-warning text-dark"
                      }`}
                    >
                      {dealer.status}
                    </span>

                  </div>

                </div>

                {/* Details */}
                <div className="mt-3">

                  <div className="inventory-row">
                    <span className="inventory-label">
                      Brand
                    </span>

                    <span>{dealer.brand}</span>
                  </div>

                  <div className="inventory-row">
                    <span className="inventory-label">
                      MFG Year
                    </span>

                    <span>{dealer.manufacture_year}</span>
                  </div>

                  <div className="inventory-row">
                    <span className="inventory-label">
                     User Name
                    </span>

                    <span>{dealer.name}</span>
                  </div>

                </div>

                {/* Bottom Buttons */}
                <div className="mt-auto pt-3 d-flex justify-content-between gap-2">

                  <button
                    className="btn-action btn-primary-custom"
                    onClick={() => {
                      setSelectedMachine(dealer);
                      setShowMachineModal(true);
                    }}
                  >
                    View
                  </button>

                  <button
                    className="btn-action btn-warning-custom"
                    onClick={() =>
                      navigate("/admin/enquiry", {
                        state: {
                          dealer: dealer,
                        },
                      })
                    }
                  >
                    Enquiry
                  </button>

                   

                </div>

              </div>

            </div>
          ))
        ) : (
          <div className="col-12">
            <div className="alert alert-light text-center shadow-sm rounded-4">
              No Machines Found
            </div>
          </div>
        )}

      </div>
    </div>

   
  </>
)}


                
{showMachineModal && (
  <div
    className="modal d-block"
    style={{
      background: "rgba(0,0,0,.55)",
      backdropFilter: "blur(4px)",
      zIndex: 9999,
    }}
  >
    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg modal-fullscreen-sm-down">

      <div
        className="modal-content border-0 shadow-lg"
        style={{ borderRadius: "18px", overflow: "hidden" }}
      >

        {/* HEADER */}
        <div className="d-flex justify-content-between align-items-center px-3 px-md-4 py-3 bg-primary">
          <div>
            <h5 className="text-white mb-0 fw-bold">
              Machine Details
            </h5>
            <small className="text-white">
              {selectedMachine?.machine_name}
            </small>
          </div>

          <button
            className="btn btn-light btn-sm"
            onClick={() => {
              setShowMachineModal(false);
              setSelectedMachine(null);
            }}
          >
            ✕
          </button>
        </div>

        {/* BODY */}
        <div className="p-3 p-md-4">

          <div className="row g-3">

            {/* LEFT SIDE */}
            <div className="col-12 col-lg-5">

              <img
                src={
    selectedMachine?.imgs
      ? `https://api.krimotion.in/aUploads/${selectedMachine.imgs.split(",")[0]}`
      : ""
  }
                alt="Machine"
                className="img-fluid rounded shadow-sm border w-100"
                style={{
                  maxHeight: "350px",
                  objectFit: "cover",
                }}
              />

              {/* GALLERY */}
              <div className="row mt-3 g-2">
                {selectedMachine?.gallery?.map((img, index) => (
                  <div className="col-3 col-sm-3" key={index}>
                    <img
                      src={`https://api.krimotion.in/aUploads/${img}`}
                      className="img-fluid rounded border w-100"
                      style={{
                        height: "70px",
                        objectFit: "cover",
                        cursor: "pointer",
                      }}
                      alt=""
                    />
                  </div>
                ))}
              </div>

            </div>

            {/* RIGHT SIDE */}
            <div className="col-12 col-lg-7">

              <div className="row g-3">

                <div className="col-6">
                  <label className="text-muted">Machine Name</label>
                  <h6>{selectedMachine?.machine_name}</h6>
                </div>

                <div className="col-6">
                  <label className="text-muted">Brand</label>
                  <h6>{selectedMachine?.brand}</h6>
                </div>

                <div className="col-6">
                  <label className="text-muted">Manufacturing Year</label>
                  <h6>{selectedMachine?.manufacture_year}</h6>
                </div>

                <div className="col-6 d-flex flex-column gap-1">
                  <label className="text-muted">Status</label>
                  <span
                    className={`badge ${
                      selectedMachine?.status === "Available"
                        ? "bg-success"
                        : "bg-warning"
                    }`}
                    style={{
                      width: "fit-content",
                      padding: "6px 12px",
                    }}
                  >
                    {selectedMachine?.status}
                  </span>
                </div>

                <div className="col-6">
                  <label className="text-muted">Dealer</label>
                  <h6>{selectedMachine?.name}</h6>
                </div>

                <div className="col-6">
                  <label className="text-muted">Mobile</label>
                  <h6>{selectedMachine?.mobile}</h6>
                </div>

                <div className="col-6">
                  <label className="text-muted">Driver Pay</label>
                  <h6>{selectedMachine?.driver_pay}</h6>
                </div>

                <div className="col-6">
                  <label className="text-muted">Assigned Driver</label>
                  <h6>{selectedMachine?.d_name}</h6>
                </div>

              </div>
            </div>

          </div>
        </div>

        {/* FOOTER */}
        <div className="px-3 px-md-4 pb-3 text-end">
          <button
            className="btn btn-secondary w-100 w-md-auto mb-2"
            onClick={() => {
              setShowMachineModal(false);
              setSelectedMachine(null);
            }}
          >
            Close
          </button>
        </div>

      </div>
    </div>
  </div>
)}
    </div>
   </>
  )
}

export default MachineList
